export var MovieClipProperties;
(function (MovieClipProperties) {
    MovieClipProperties[MovieClipProperties["_x"] = 0] = "_x";
    MovieClipProperties[MovieClipProperties["_y"] = 1] = "_y";
    MovieClipProperties[MovieClipProperties["_xscale"] = 2] = "_xscale";
    MovieClipProperties[MovieClipProperties["_yscale"] = 3] = "_yscale";
    MovieClipProperties[MovieClipProperties["_currentframe"] = 4] = "_currentframe";
    MovieClipProperties[MovieClipProperties["_totalframes"] = 5] = "_totalframes";
    MovieClipProperties[MovieClipProperties["_alpha"] = 6] = "_alpha";
    MovieClipProperties[MovieClipProperties["_visible"] = 7] = "_visible";
    MovieClipProperties[MovieClipProperties["_width"] = 8] = "_width";
    MovieClipProperties[MovieClipProperties["_height"] = 9] = "_height";
    MovieClipProperties[MovieClipProperties["_rotation"] = 10] = "_rotation";
    MovieClipProperties[MovieClipProperties["_target"] = 11] = "_target";
    MovieClipProperties[MovieClipProperties["_framesloaded"] = 12] = "_framesloaded";
    MovieClipProperties[MovieClipProperties["_name"] = 13] = "_name";
    MovieClipProperties[MovieClipProperties["_droptarget"] = 14] = "_droptarget";
    MovieClipProperties[MovieClipProperties["_url"] = 15] = "_url";
    MovieClipProperties[MovieClipProperties["_highquality"] = 16] = "_highquality";
    MovieClipProperties[MovieClipProperties["_focusrect"] = 17] = "_focusrect";
    MovieClipProperties[MovieClipProperties["_soundbuftime"] = 18] = "_soundbuftime";
    MovieClipProperties[MovieClipProperties["_quality"] = 19] = "_quality";
    MovieClipProperties[MovieClipProperties["_xmouse"] = 20] = "_xmouse";
    MovieClipProperties[MovieClipProperties["_ymouse"] = 21] = "_ymouse";
})(MovieClipProperties || (MovieClipProperties = {}));
